/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface PostUsersCurrentProfileRequest {

    twitter_profile?: string;

    facebook_profile?: string;

    googleplus_profile?: string;

    instagram_profile?: string;

    linkedin_url?: string;

    location?: string;

    pronouns?: string;

    is_tyt_army?: boolean;

    tagline?: string;

    featured_at?: string;

    favorite_quote?: string;

    favorite_tyt_memory?: string;

    favorite_inspirational_figure?: string;

    political_views?: string;

    religion_or_philosophy?: string;

    bio?: string;

    spot_id?: string;

    username?: string;

    signed_up_at?: string;

    member_number?: string;

    member_since?: string;

    display_name?: string;

    avatar?: string;

    cover_photo?: string;

    first_name?: string;

    last_name?: string;

    metadata?: { [key : string]: any };

    additional_email?: string;

    city?: string;

    state?: string;

    zip?: string;

    country?: string;

    birthday?: string;

    gender?: string;

    shout_out_opt_in?: boolean;

    is_public?: boolean;

}

@Model('PostUsersCurrentProfile')
export class ApiPostUsersCurrentProfile extends BaseModel implements PostUsersCurrentProfileRequest {

    
    
    twitter_profile: string;

    
    
    facebook_profile: string;

    
    
    googleplus_profile: string;

    
    
    instagram_profile: string;

    
    
    linkedin_url: string;

    
    
    location: string;

    
    
    pronouns: string;

    
    
    is_tyt_army: boolean;

    
    
    tagline: string;

    
    
    featured_at: string;

    
    
    favorite_quote: string;

    
    
    favorite_tyt_memory: string;

    
    
    favorite_inspirational_figure: string;

    
    
    political_views: string;

    
    
    religion_or_philosophy: string;

    
    
    bio: string;

    
    
    spot_id: string;

    
    
    username: string;

    
    
    signed_up_at: string;

    
    
    member_number: string;

    
    
    member_since: string;

    
    
    display_name: string;

    
    
    avatar: string;

    
    
    cover_photo: string;

    
    
    first_name: string;

    
    
    last_name: string;

    
    
    metadata: { [key : string]: any };

    
    
    additional_email: string;

    
    
    city: string;

    
    
    state: string;

    
    
    zip: string;

    
    
    country: string;

    
    
    birthday: string;

    
    
    gender: string;

    
    
    shout_out_opt_in: boolean;

    
    
    is_public: boolean;

}
